"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCompletionItem = void 0;
const types_1 = require("../types");
const toCompletionItem = (value, range, rest = {}) => {
    const item = Object.assign({ label: value, insertText: value, kind: types_1.CompletionItemKind.Field, sortText: types_1.CompletionItemPriority.Medium, range }, rest);
    return item;
};
exports.toCompletionItem = toCompletionItem;
//# sourceMappingURL=toCompletionItem.js.map